import React from 'react';
import { QuestionnaireItem } from '../QuestionnairePreview';
import QuestionnairePreviewItems from '../QuestionnairePreviewItems';
// @ts-ignore
import styles from './../QuestionnairePreview.module.scss';

interface Props {
	item: QuestionnaireItem;
}

const QuestionnairePreviewCollapse: React.FC<Props> = ({ item }) => {
	return (
		<div className={styles.collapse}>
			<div className={styles.collapseTitle}>{item.title}</div>
			<div className={styles.collapseContent}>
				<QuestionnairePreviewItems children={item.children} />
			</div>
		</div>
	);
};

export default QuestionnairePreviewCollapse;
